import React, {forwardRef} from "react";

import {Image, View}  from 'react-native'

import cores from '../util/cores'



const Imagem = forwardRef((props, ref) => {

    return (
        props.imagem!=null?
        (<Image source={{uri: "data:image/jpeg;base64,"+props.imagem}} 
            style={{height: props.tamanho, width: props.tamanho, borderRadius:props.redondo?parseInt(props.tamanho/2):10, margin:10}}/>):	
        (<Image source={require("../imgs/imagem.png")} style={{height: props.tamanho, width: props.tamanho, margin:10}}/>)
	)
});

export default Imagem;